import { useEffect } from "react";
import ConfigProjectEdit from "../ConfigProject/ConfigProjectEdit";
import Tabs from "../Elements/Tabs";
import ListSourceEdit from "../Fuente/ListSourceEdit";
import { useUser } from "@/app/context/UserContext";
import { TypeLayout } from "@/app/constants/enums";
import IntegrationForm from "../Integration/IntegrationForm";
import QuotaConfiguration from "../Quotas/QuotaConfiguration";
import Evaluacion from "../Evaluacion/Evaluacion";
import ItemPermissions from "../Permissions/ItemPermissions";
import ChatbotConversations from "../Conversations/ChatbotConversations";


export default function LayoutPrincipal() {
  
  const { typeLayout} = useUser();
   
  const tabs = [
    { id: 1, label: "Configuración", content: <ConfigProjectEdit/> },
    { id: 2, label: "Base de Conocimientos", content: <ListSourceEdit />},
  ];
  
  // Agregar dinámicamente el nuevo ítem si `typeLayout` es "conversation" (typeLayout === TypeLayout.Conversation || typeLayout === TypeLayout.Personal)
  if (true) { tabs.push({ id: 3, label: "Integración", content: <IntegrationForm/>, });
  } 

  tabs.push(
    { id: 4, label: "Permisos", content: <ItemPermissions/>,},
    //{ id: 5, label: "Chat", content: <div id="n-cnt-chat" className="overflow-x-hidden scroll-custom"><Chat /></div>  } 
  );
  
  tabs.push(
    { id: 5, label: "Cuotas", content: <QuotaConfiguration/>,},
    //{ id: 5, label: "Chat", content: <div id="n-cnt-chat" className="overflow-x-hidden scroll-custom"><Chat /></div>  } 
  );

  tabs.push(
    { id: 6, label: "Evaluación", content: <Evaluacion/>,},
    //{ id: 5, label: "Chat", content: <div id="n-cnt-chat" className="overflow-x-hidden scroll-custom"><Chat /></div>  } 
  );
  tabs.push(
    {id:7, label: "Conversaciones", content: <ChatbotConversations /> }
  )

  useEffect(() => {
    const ajustarAltura = (id:string) => {
      let h = 270; 
      const elemento = document.getElementById(id);
        if (elemento) { 
            elemento.style.height = `${window.innerHeight-h}px`; 
        } 
    };
    const ajustarAlturaBody = () => { 
      ajustarAltura('n-cnt-chat');
        
    }; 
    ajustarAlturaBody();  // Establece la altura inicial
    window.addEventListener('resize', ajustarAlturaBody); 
    return () => window.removeEventListener('resize', ajustarAlturaBody);
  }, []);

 

  return (
    <div className={` ${typeLayout == TypeLayout.Conversation || typeLayout == TypeLayout.Personal?"w-10/12":"w-full"} p-4`}>
      <div className="flex justify-between items-center">
        <h3 className={`text-lg font-bold opacity-100 scale-100`}>Configuración de asistente</h3>
      </div>
      <div className="pt-8 overflow-x-hidden scroll-custom "  >
        <Tabs tabs={tabs} />         
      </div>
      
    </div> 
  );
}
